import { ReactNode, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { useKeycloakAuth } from '@/auth/KeycloakProvider';
import { PageLoading } from '@/ui/PageLoading';

import { LoggedType, useUserAuthContext } from '../AuthTokenContextProvider/UserAuthContext';

type Props = {
  children: ReactNode;
};

export default function AuthGuard({ children }: Props) {
  const { status } = useUserAuthContext();
  const { login } = useKeycloakAuth();
  const location = useLocation();
  const loginCalledRef = useRef(false);

  console.log('[AuthGuard] status=%s', status);
  if (status === LoggedType.LOGGED_IN) return <>{children}</>;
  if (status === LoggedType.LOGGED_OUT) {
    if (!loginCalledRef.current) {
      loginCalledRef.current = true;
      const returnUrl = `${location.pathname}${location.search}`;
      console.log('[AuthGuard] LOGGED_OUT → calling login(returnUrl=%s)', returnUrl);
      login(returnUrl);
    }
    return <PageLoading />;
  }
  if (status === LoggedType.LOADING) return <PageLoading />;
}
